import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { getContextRoot, navigateToPath, getLanguageValue } from "../common/functions";
import CONSTANTS from '../common/constants';
import { useLocation } from 'react-router-dom';
import 'flag-icons/css/flag-icons.min.css';

function HeaderWithLogoBackground(props) {
    const location = useLocation();
    const dispatch = useDispatch();

    return (
        <HeaderWithLogoBackgroundStyle className={props.className || ''}>
            <div className="background-component" />
            {CONSTANTS.YOUTUBE_ON_HEADER_ENABLED && (
                <div className="youtube-container">
                    <iframe
                        id="ytplayer"
                        type="text/html"
                        src="https://www.youtube.com/embed/s5Pfpu0uoH8?autoplay=1"
                        frameBorder="0"
                        allowFullScreen
                    />
                </div>
            )}
            <div className="logo-wrapper">
                <img src={getContextRoot() + 'images/logo.png'} alt="Logo" className="logo-img" />
                <div className="flag-circle">
                    <span className="fi fi-et" /> {/* 🇪🇹 Ethiopia Flag */}
                </div>
            </div>
        </HeaderWithLogoBackgroundStyle>
    );
}

const HeaderWithLogoBackgroundStyle = styled.div`
  position: relative;
  height: 280px;

  .background-component {
    background: url('${getContextRoot() + 'images/country_bg.jpg'}') no-repeat 100% 0;
    background-size: cover;
    width: 100%;
    height: 280px;
    @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
      opacity: 0.5;
    }
  }

  .youtube-container {
    position: absolute;
    top: 55px;
    left: 182px;
    height: 200px;
    @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
      left: calc(50% - 144px);
      z-index: 1;
    }
    iframe {
      border-radius: 20px;
      width: 100%;
      height: 100%;
    }
  }

  .logo-wrapper {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 252px;
    height: 252px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
      left: 50%;
      transform: translateX(-50%);
      width: 252px;
      height: 252px;
    }

    .logo-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .flag-circle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, calc(-50% - 35px));
      width: 61px;
      height: 61px;
      border-radius: 50%;
      background: white;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

      .fi {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
      }
    }
  }
`;

export default HeaderWithLogoBackground;
